import { create } from 'zustand';
import { setApiBusiness } from './api';

const STORAGE_KEY = 'eb.business';

function stored(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

interface WorkspaceState {
  /** Active business; every tenant-scoped request is sent for this business. */
  businessId: string | null;
  setBusiness: (id: string | null) => void;
}

export const useWorkspace = create<WorkspaceState>((set) => {
  const initial = stored();
  setApiBusiness(initial);
  return {
    businessId: initial,
    setBusiness: (id) => {
      setApiBusiness(id);
      try {
        if (id) localStorage.setItem(STORAGE_KEY, id);
        else localStorage.removeItem(STORAGE_KEY);
      } catch {
        // Storage unavailable: the choice lasts for this tab only.
      }
      set({ businessId: id });
    },
  };
});
